(ns app.front.view.group.admin.config.licence-notifications
  (:require [app.domain.licence.model :as licence-model]
            [app.front.view.group.admin.config.notifications :as notification-config]
            [app.front.view.group.admin.subs :as gas]
            [core.front.event :refer [<sub]]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(def attr :group.config/licence-notifications)

(rf/reg-sub ::show-notification-editor?
  (fn [[_ _ group-config-id]]
    [(rf/subscribe [::gas/has-feature? :group.feature/licence-notifications])
     (rf/subscribe [::gas/group-config-level group-config-id])])
  (fn [[has-feature? level] [_ permit-type]]
    (and has-feature?
         (case permit-type
           :permit-type/L
           (licence-model/show-notification-controls-for-level? level)

           ;; For CR only permit-type level configuration makes sense
           ;; - Categories are probably new/renewal, which should generate registrations that behave identically
           ;; - An application can have multiple work types, so having work-type specific configurations probably won't make sense
           ;; - Work targets aren't used at all
           :permit-type/CR
           (= level :group-config.level/permit-type)
           ;; just in case, a default clause
           false))))

(defn editor [{:keys [tr permit-type target] :as editor-ctx}]
  (when (<sub [::show-notification-editor? permit-type target])
    [notification-config/editor
     (util/mmap {:title (tr [:group-admin/licence-notifications])
                 :types licence-model/notification-types}
                attr)
     editor-ctx]))

(defn config->values
  [config]
  (notification-config/config->values attr config))

(defn valid?
  [group-config _parent-config]
  ;; We could also check that the intervals (including the inherited ones)
  ;; are strictly increasing, but that requires better error reporting as such
  ;; requirements could be violated on the category level by altering
  ;; the permit-level values.
  (or (not (<sub [::gas/has-feature? :group.feature/licence-notifications]))
      (notification-config/valid-configs? attr group-config)))
